export default "__VITE_ASSET__MVOmv06R__"